import React, { Component } from 'react';
import '../less/index.less';
import advantage_img_1 from '../img/advantage_img_1.png';
import advantage_img_2 from '../img/advantage_img_2.png';
import advantage_img_3 from '../img/advantage_img_3.png';
import advantage_img_4 from '../img/advantage_img_4.png';
import advantage_img_5 from '../img/advantage_img_5.png';
import advantage_img_6 from '../img/advantage_img_6.png';
import advantage_img_7 from '../img/advantage_img_7.png';
import advantage_list_img_1 from '../img/advantage_list_img_1.svg';
import advantage_list_img_2 from '../img/advantage_list_img_2.svg';
import advantage_list_img_3 from '../img/advantage_list_img_3.svg';
import advantage_list_img_4 from '../img/advantage_list_img_4.svg';
import advantage_list_img_5 from '../img/advantage_list_img_5.svg';
import advantage_list_img_6 from '../img/advantage_list_img_6.svg';
import arrow_right from '../img/arrow_right.svg';
import l10n from '../../../../../../../services/l10n/ua.json'
import CustomDropdown from "../../../../../../../auxiliary-components/shared/CustomDropdown";



const menu_content = [
  {
    id: 1,
    btn: 'ABANK_24_ADVANTAGE_BTN_1',
    title: 'ABANK_24_ADVANTAGE_TITLE_1',
    img: advantage_img_1,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_1_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_1_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_1_3'
      },
      {
        img: advantage_list_img_4,
        text: 'ABANK_24_ADVANTAGE_LIST_1_4'
      },
      {
        img: advantage_list_img_5,
        text: 'ABANK_24_ADVANTAGE_LIST_1_5'
      },
    ]
  },
  {
    id: 2,
    btn: 'ABANK_24_ADVANTAGE_BTN_2',
    title: 'ABANK_24_ADVANTAGE_TITLE_2',
    img: advantage_img_2,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_2_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_2_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_2_3'
      },
    ]
  },
  {
    id: 3,
    btn: 'ABANK_24_ADVANTAGE_BTN_3',
    title: 'ABANK_24_ADVANTAGE_TITLE_3',
    img: advantage_img_3,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_3_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_3_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_3_3'
      },
      {
        img: advantage_list_img_4,
        text: 'ABANK_24_ADVANTAGE_LIST_3_4'
      },
    ]
  },
  {
    id: 4,
    btn: 'ABANK_24_ADVANTAGE_BTN_4',
    title: 'ABANK_24_ADVANTAGE_TITLE_4',
    img: advantage_img_4,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_4_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_4_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_4_3'
      },
      {
        img: advantage_list_img_4,
        text: 'ABANK_24_ADVANTAGE_LIST_4_4'
      },
    ]
  },
  {
    id: 5,
    btn: 'ABANK_24_ADVANTAGE_BTN_5',
    title: 'ABANK_24_ADVANTAGE_TITLE_5',
    img: advantage_img_5,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_5_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_5_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_5_3'
      },
    ]
  },
  {
    id: 6,
    btn: 'ABANK_24_ADVANTAGE_BTN_6',
    title: 'ABANK_24_ADVANTAGE_TITLE_6',
    img: advantage_img_6,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_6_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_6_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_6_3'
      },
      {
        img: advantage_list_img_4,
        text: 'ABANK_24_ADVANTAGE_LIST_6_4'
      },
      {
        img: advantage_list_img_5,
        text: 'ABANK_24_ADVANTAGE_LIST_6_5'
      },
      {
        img: advantage_list_img_6,
        text: 'ABANK_24_ADVANTAGE_LIST_6_6'
      },
    ]
  },
  {
    id: 7,
    btn: 'ABANK_24_ADVANTAGE_BTN_7',
    title: 'ABANK_24_ADVANTAGE_TITLE_11',
    img: advantage_img_7,
    list : [
      {
        img: advantage_list_img_1,
        text: 'ABANK_24_ADVANTAGE_LIST_7_1'
      },
      {
        img: advantage_list_img_2,
        text: 'ABANK_24_ADVANTAGE_LIST_7_2'
      },
      {
        img: advantage_list_img_3,
        text: 'ABANK_24_ADVANTAGE_LIST_7_3'
      },
      {
        img: advantage_list_img_4,
        text: 'ABANK_24_ADVANTAGE_LIST_7_4'
      },
      {
        img: advantage_list_img_5,
        text: 'ABANK_24_ADVANTAGE_LIST_7_5'
      },
    ]
  }
];


class Advantage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeContent: menu_content[0]
    };
  }

  setActiveContent = (item) => {
    this.setState({ activeContent: item });
  };

  render() {
    const { activeContent } = this.state;
    const isMobile = this.props.isMobile;

    return (
      !isMobile ?
        (
          <div className="advantage-block">
            <div className="button-column">
              {menu_content.map(item => (
                <button className='button-column-item' key={item.id} onClick={() => this.setActiveContent(item)}>
                  {l10n[item.btn]}
                  <img src={arrow_right} alt="arrow_right" />
                </button>
              ))}
            </div>
            <div className="content-area">
              <img className="content-area-img" src={activeContent.img} alt={activeContent.id + '_img'} />
              <div className='content-area-wrapper'>
                <div className='title' dangerouslySetInnerHTML={{__html: l10n[activeContent.title]}}></div>
                <div className='list'>
                  {
                    activeContent.list.map(item => (
                      <div className='list-item'>
                        <img className='list-item-img' src={item.img} alt={item.text} />
                        <div className='list-item-text' dangerouslySetInnerHTML={{__html: l10n[item.text]}}></div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        )
        :
        (
          <div className='mobile-advantage'>
            {
              menu_content.map(item => (
                <CustomDropdown title={l10n[item.btn]} key={item.id} classNameDropDown={"mobile-advantage-item"}>
                  <div className='mobile-advantage-item-content'>
                    <img className="img" src={item.img} alt={item.id + '_img'} />
                    <div className='shadow'></div>
                    <div className='title' dangerouslySetInnerHTML={{__html: l10n[item.title]}}></div>
                    <div className='list'>
                      {
                        item.list.map(i => (
                          <div className='list-item'>
                            <img className='list-item-img' src={i.img} alt={i.text} />
                            <div className='list-item-text' dangerouslySetInnerHTML={{__html: l10n[i.text]}}></div>
                          </div>
                        ))
                      }
                    </div>
                  </div>

                </CustomDropdown>
              ))
            }
          </div>
        )
    );
  }
}

export default Advantage;